var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.banner && _vm.banner.path)?_c('van-image',{staticClass:"top-banner-container",attrs:{"src":_vm.banner.path},on:{"click":_vm.jump},scopedSlots:_vm._u([(_vm.loading)?{key:"loading",fn:function(){return [_c('van-loading')]},proxy:true}:null],null,true)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }